import { useNavigate } from 'react-router-dom'
import { formatDuration } from './format'

/** Гаджет: Оперативный контроль: лента активных рейсов. */

const LEVEL_LABEL = { risk: 'Риск', attention: 'Внимание', ok: 'В графике' }

export function OpsControlWidget({ data }) {
  const navigate = useNavigate()

  if (!data.items.length) {
    return <p className="widget-empty">Активных рейсов сейчас нет</p>
  }

  return (
    <div className="ops">
      <div className="ops__summary">
        <span className="ops__count">{data.counts.total} в рейсе</span>
        {data.counts.risk > 0 && (
          <span className="chip chip--danger">{data.counts.risk} с риском</span>
        )}
        {data.counts.attention > 0 && (
          <span className="chip chip--warning">{data.counts.attention} затянулись</span>
        )}
        {data.estimated_count > 0 && data.baseline_min ? (
          <span className="ops__baseline" title="Средняя длительность рейса за 30 дней">
            норма ≈ {formatDuration(data.baseline_min)}
          </span>
        ) : null}
      </div>

      <ul className="widget-list">
        {data.items.map((t) => (
          <li key={t.trip_id}>
            <button
              type="button"
              className={`ops__row ops__row--${t.level}`}
              onClick={() => navigate(`/admin/trips/${t.trip_id}`)}
            >
              <span className="ops__marker" aria-hidden="true" />
              <span className="ops__main">
                <span className="ops__car">
                  {t.car}
                  {t.plate ? <span className="plate">{t.plate}</span> : null}
                </span>
                <span className="ops__driver">{t.driver}</span>
              </span>
              <span className="ops__time">
                <span className="ops__duration">
                  {t.basis === 'plan' && t.late_min > 0
                    ? `+${formatDuration(t.late_min)}`
                    : formatDuration(t.running_min)}
                </span>
                <span className="ops__level">
                  {t.basis === 'plan' ? LEVEL_LABEL[t.level] : `≈ ${LEVEL_LABEL[t.level]}`}
                </span>
              </span>
            </button>
          </li>
        ))}
      </ul>

      {data.estimated_count > 0 && (
        <p className="widget-note">
          {data.planned_count > 0
            ? `У ${data.estimated_count} из ${data.counts.total} рейсов нет плана — для них
               отклонение оценивается по средней длительности и отмечено знаком ≈.`
            : `Планового времени завершения ни у одного рейса нет — отклонение
               оценивается по средней длительности за 30 дней и отмечено знаком ≈.`}
        </p>
      )}
    </div>
  )
}
